<template>
    <div>
        <div class="top_unit_comment">
            <div class="top_name_box position_relate">
              <div class="mgb_10" style="display: flex;justify-content: space-between;">
                {{brandStoreName}}
                <div class="check_btn_right_csv" style="display: flex;justify-content: space-between;">
                  <div v-if="!isStoreManager" style="padding: 8px 8px 8px 0px;">
                    アラート通知
                    <input type="checkbox" name="checkbox02" :id="upperTitle" v-model="data.reportCommentAlert.healthCheck.isAlert" :value="1">
                    <label class="checkbox02" :for="upperTitle"></label>
                  </div>
                  <div>
                    <div class="btn_all_topButton_csv">
                      <a href="#" @click.prevent.stop="allCsvExport()">全帳票一括CSV出力</a>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="isStaffRegistered">
                  責任者：
                  <select id="historyFilter" :value="staffId" @change="onChange">
                      <option v-for="staff in data.staffList" :key="staff['id']" :value="staff['id']">{{staff['staffName']}}</option>
                  </select>
              </div>
              <p v-if="!isStaffRegistered">責任者：{{managerName}}</p>
            </div>
            <div class="top_center_box pt-4">
                <p v-if="upperTitle !== ''" class="tex_s">{{upperTitle}}</p>
                <p v-if="lowerTitle !== ''" class="tex_l">{{lowerTitle}}</p>
            </div>
            <div v-if="errorText || validationErrorText">
                <Message :validationMessage="alertMessage" />
            </div>
            <div class="textarea_unit wd876 mgt_15">
                <p class="text-danger font-weight-bold text_white_space_pre_wrap">{{errorText}}</p>
                <p class="text-danger font-weight-bold text_white_space_pre_wrap">{{alertMessage}}</p>
            </div>
            <div v-if="!isLoading" class="textarea_unit wd876 mgt_15">
                <p class="textarea_name">店舗管理者<span class="mgl_20">最終確認日時 {{storeManagerCommentDatetime}} </span></p>
                <textarea v-model="data.healthCheck.comment.storeManager.comment"  :disabled="!isStoreManager" class="textarea_box" placeholder="統括コメントを入力" maxlength="200" @change="checkComent"></textarea>
                <p v-if="isStoreManager && validationErrorText" class="text-danger">{{validationErrorText}}</p>
            </div>
            <div v-if="!isLoading"  class="textarea_unit wd876 mgt_15">
                <p class="textarea_name">企業管理者<span class="mgl_20">最終確認日時 {{companyManagerCommentDatetime}} </span>
                  <span v-if="data.healthCheck.comment.companyManager.reportCommentAlert == 0" style="float: right;color: red">店舗未対応</span>
                  <span v-if="data.healthCheck.comment.companyManager.reportCommentAlert == 1" style="float: right;color: blue">店舗対応済み:{{data.healthCheck.comment.companyManager.staffName}}</span>
                </p>
                <textarea v-model="data.healthCheck.comment.companyManager.comment" :disabled="!isCompanyManager" class="textarea_box" placeholder="統括コメントを入力" maxlength="200" @change="checkComent"></textarea>
                <p v-if="isCompanyManager && validationErrorText" class="text-danger">{{validationErrorText}}</p>
            </div>
            <div v-if="!isLoading"  class="textarea_unit wd876 mgt_15">
                <p class="textarea_name">その他管理者<span class="mgl_20">最終確認日時 {{otherManagerCommentDatetime}} </span>
                  <span v-if="data.healthCheck.comment.otherManager.reportCommentAlert == 0" style="float: right;color: red">店舗未対応</span>
                  <span v-if="data.healthCheck.comment.otherManager.reportCommentAlert == 1" style="float: right;color: blue">店舗対応済み:{{data.healthCheck.comment.otherManager.staffName}}</span>
                </p>
                <textarea v-model="data.healthCheck.comment.otherManager.comment" :disabled="!isOtherManager" class="textarea_box" placeholder="統括コメントを入力" maxlength="200" @change="checkComent"></textarea>
                <p v-if="isOtherManager && validationErrorText" class="text-danger">{{validationErrorText}}</p>
            </div>
        </div>
        <div v-if="upperTitle !== null && lowerTitle !== null" class="wd876" style="height: 40px">
            <div class="check_btn_right_csv">
                <div class="btn_csv">
                    <a href="#" @click.prevent.stop="csvExport()">CSV出力</a>
                </div>
            </div>
        </div>
        <div class="comment_tbl_unit wd876 tbl_ht_comment tbl_bg_green mgt_15">
            <table>
                <tbody>
                <tr>
                    <th class="wd200 tbl_tex_left" @click="sortBy('staffId')">
                        氏名
                        <img class="triangle" v-if="sortOrders['staffId'] > 0" src="../assets/img/UnderTriangleWhite.png" width="15px" height="13px" alt="UnderTriangle">
                        <img class="triangle" v-if="sortOrders['staffId'] <= 0" src="../assets/img/UpTriangleWhite.png" width="15px" height="13px" alt="UpTriangle">
                    </th>
                    <th class="wd70" @click="sortBy('updatedDatetime')">
                        時刻
                        <img class="triangle" v-if="sortOrders['updatedDatetime'] > 0" src="../assets/img/UnderTriangleWhite.png" width="15px" height="13px" alt="UnderTriangle">
                        <img class="triangle" v-if="sortOrders['updatedDatetime'] <= 0" src="../assets/img/UpTriangleWhite.png" width="15px" height="13px" alt="UpTriangle">
                    </th>
                    <th class="wd240 tbl_tex_left">逸脱</th>
                    <th class="tbl_tex_left">コメント</th>
                </tr>
                <tr v-for="history in filteredDatas" :key="history.id">
                    <td class="text-wrap">
                        {{history.staffName}}
                    </td>
                    <td class="wd70">{{history.updatedTime}}</td>
                    <td v-show="history.ngCount > 0" class="tbl_comment text-wrap tbl_bg_red">有：{{ history.ng | join('、') }}</td>
                    <td v-show="history.ngCount === 0" class="tbl_comment">無</td>
                    <td class="tbl_comment text-wrap">{{history.comment}}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">CSV出力</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>CSV出力が完了しました。</p>
                    </div>

                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeModel">OK</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isCsvLoading">
            <pulse-loader class="w-100 text-center" :loading="isCsvLoading"></pulse-loader>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'HealthCheckReport',
        filters: {
            join: function (value, separator) {
                return Object.values(value).join(separator)
            }
        },
        props: {
            data: {
                type: Object,
                required: true,
            },
            upperTitle: {
                type: String
            },
            lowerTitle: {
                type: String
            },
            errorText: {
                type: String
            },
            validationErrorText: {
                type: String
            },
            isLoading: {
                type: Boolean
            },
            selectDate:{
                type: String
            },
            staffId: {
                type: Number
            }
        },
        data: function () {
            return {
                sortKey: '',
                sortOrders:{
                    'staffId': 1,
                    'updatedDatetime': 1
                },
                storeManagerComment: "",
                companyManagerComment: "",
                otherManagerComment: "",
                showContent: false,
                isCsvLoading:false,
                addFormFlg:true,
                alertMessage:"",
                storeManagerCommentDatetime: '',
                companyManagerCommentDatetime: '',
                otherManagerCommentDatetime: '',
            }
        },
        created() {
            this.storeManagerComment = this.data.healthCheck.comment.storeManager.comment;
            this.companyManagerComment = this.data.healthCheck.comment.companyManager.comment
            this.otherManagerComment = this.data.healthCheck.comment.otherManager.comment
            this.lastUpdateTimeStore()
            this.lastUpdateTimeCompany()
            this.lastUpdateTimeOther()
        },
        computed: {
            managerName: function () {
                return this.$store.getters['store/adminName']
            },
            role: function () {
                return Number(this.$store.getters['manager/manager'].authorityKbn)
            },
            isStoreManager: function () {
                return this.role === 4
            },
            isCompanyManager: function () {
                return this.role === 2
            },
            isOtherManager: function () {
                return this.role === 6
            },
            historyList: function () {
              return this.data.healthCheck.historyList;
            },
            filteredDatas:function(){
                var data = this.historyList;

                var sortKey = this.sortKey;

                if(sortKey){
                    var order = this.sortOrders[sortKey] || 1;
                    data = data.slice().sort(function(a,b){
                        a = a[sortKey];
                        b = b[sortKey];
                        return(a === b ? 0 : a > b? 1 : -1) * order;
                    });
                }

                return data;

            },
            brandStoreName: function () {
                let brandName = this.$store.getters['brand/name']
                let storeName = this.$store.getters['store/name']

                if (brandName == null) {
                    brandName = ''
                }

                if (storeName == null) {
                    storeName = ''
                }

                return brandName + '・' + storeName
            },
            brandPath: function () {
                return this.$store.getters['brand/path']
            },
            isStaffRegistered: function () {
                if(this.role === 4 && this.data.staffList != null){
                    return true
                }
                return false
            },
        },
        methods: {
            columnJoin: function (value, key, separator) {
                if (! Array.isArray(value)) {
                    return ''
                }
                return value.map(x => x[key]).join(separator)
            },
            sortBy:function(key){
                this.sortKey = key;
                this.sortOrders[key] = this.sortOrders[key] * -1;

            },
            checkComent(){

                // コメントの差分をチェックする
                if(this.storeManagerComment !== this.data.healthCheck.comment.storeManager.comment ||
                    this.companyManagerComment !== this.data.healthCheck.comment.companyManager.comment ||
                    this.otherManagerComment !== this.data.healthCheck.comment.otherManager.comment){

                    // 親のコメントフラグを書き換える
                    this.$parent.commentFlg = true;
                }
                else{
                    this.$parent.commentFlg = false;
                }
            },
            async csvExport(){

                this.addFormFlg = true;
                this.isCsvLoading = true;
                this.alertMessage = "";

                var params = {
                    start_date: this.selectDate,end_date:this.selectDate
                };

                var brandId = this.$store.getters['brand/id'];
                var storeId = this.$store.getters['store/id'];

                // API呼び出し
                await this.$axios
                    .get(this.$apiEndpoint + 'manage/brand/'+ brandId +'/store/' + storeId + '/report/csv/allHealth' ,{params})
                    .then(response => (this.csvResponseData = response))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        this.addFormFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError);
                            if (err.customError.code == 401) {
                                //店舗管理者のtokenエラーの場合
                                this.$cookies.set('user-api-token', '', 0)
                                this.$store.dispatch('store/doClear')
                            }
                            if(error.code == 400){
                                this.alertMessage =  error.message;
                                this.scrollTop();
                            }
                        }
                        if(error.code !== 400){
                            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                        }
                    }).finally(()=> this.isCsvLoading = false);

                if(this.addFormFlg){
                    // CSV出力
                    if(!this.commonDownloadCSV(this.csvResponseData)){
                        this.alertMessage =  "CSVの出力に失敗しました。";
                        this.addFormFlg = false;
                        this.scrollTop();
                    }
                    else{
                        this.showContent = true;
                    }
                }
            },
            closeModel(){
                this.showContent = false;
            },
            scrollTop() {
                window.scrollTo(0, 0);
            },
            formatLastUpdateTime: function (lastUpdateTime) {
                lastUpdateTime = lastUpdateTime.replace(/-/g, '/')
                lastUpdateTime = lastUpdateTime.slice( 0, -3 )
                return lastUpdateTime
            },
            lastUpdateTimeStore: function () {
                if(this.data.healthCheck.comment.storeManager.commentsDatetime != "") {
                    this.storeManagerCommentDatetime = this.formatLastUpdateTime(this.data.healthCheck.comment.storeManager.commentsDatetime)
                } else {
                    this.storeManagerCommentDatetime = '-'
                }
            },
            lastUpdateTimeCompany: function () {
                if(this.data.healthCheck.comment.companyManager.commentsDatetime != "") {
                    this.companyManagerCommentDatetime = this.formatLastUpdateTime(this.data.healthCheck.comment.companyManager.commentsDatetime)
                } else {
                    this.companyManagerCommentDatetime = '-'
                }
            },
            lastUpdateTimeOther: function () {
                if(this.data.healthCheck.comment.otherManager.commentsDatetime != "") {
                    this.otherManagerCommentDatetime = this.formatLastUpdateTime(this.data.healthCheck.comment.otherManager.commentsDatetime)
                } else {
                    this.otherManagerCommentDatetime = '-'
                }
            },
            updateUserCommentDatetime(){
                if (this.isStoreManager) {
                    this.lastUpdateTimeStore()
                } else if (this.isCompanyManager) {
                    this.lastUpdateTimeCompany()
                } else {
                    this.lastUpdateTimeOther()
                }
            },
            async allCsvExport(){
              this.addFormFlg = true;
              this.isCsvLoading = true;
              this.alertMessage = "";
              var params = {
                date: this.selectDate
              };
              var brandId = this.$store.getters['brand/id'];
              var storeId = this.$store.getters['store/id'];
              var dailyReportCsvResponseData = null;
              var cookingReportCsvResponseData = null;
              var healthCheckReportCsvResponseData = null;
              // API呼び出し
              // 店舗チェック一括CSV
              await this.$axios
                  .get(this.$apiEndpoint + 'manage/brand/'+ brandId +'/store/' + storeId + '/report/csv/allDaily',{params})
                  .then(response => {
                    dailyReportCsvResponseData = response
                    // 調理チェック一括CSV
                    return this.$axios
                        .get(this.$apiEndpoint + 'manage/brand/'+ brandId +'/store/' + storeId + '/report/csv/allCooking' ,{params})
                  })
                  .then(response => {
                    cookingReportCsvResponseData = response
                    // 健康身だしなみチェックCSV
                    params = {
                      start_date: this.selectDate,end_date:this.selectDate
                    };
                    return this.$axios
                        .get(this.$apiEndpoint + 'manage/brand/'+ brandId +'/store/' + storeId + '/report/csv/health' ,{params})
                  })
                  .then(response => (healthCheckReportCsvResponseData = response))
                  .catch((err) => {
                    let error = {
                      button: {
                        path: {name: 'top', params:{brandPath: this.brandPath}}
                      }}
                    this.addFormFlg = false;
                    if (err.customError) {
                      error = Object.assign(error, err.customError);
                      if (err.customError.code == 401) {
                        //店舗管理者のtokenエラーの場合
                        this.$cookies.set('user-api-token', '', 0)
                        this.$store.dispatch('store/doClear')
                      }
                      if(error.code == 400){
                        this.alertMessage =  error.message;
                        this.scrollTop();
                      }
                    }
                    if(error.code !== 400){
                      this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }
                  }).finally(()=> this.isCsvLoading = false);
              if(this.addFormFlg){
                // CSV出力
                if(!this.commonDownloadCSV(dailyReportCsvResponseData) || !this.commonDownloadCSV(cookingReportCsvResponseData) || !this.commonDownloadCSV(healthCheckReportCsvResponseData)){
                  this.alertMessage =  "CSVの出力に失敗しました。";
                  this.addFormFlg = false;
                  this.scrollTop();
                }
                else{
                  this.showContent = true;
                }
              }
            },
            onChange(event) {
                const newValue = Number(event.target.value);
                this.$emit('update-staff-id', newValue);
            }
        }
    }
</script>
